export default "__VITE_ASSET__ba300ba4__"